const defaultTextValues = {
  sectionTitle: {
    en: 'Stream'
  },
  streamPlaceholder: {
    en: 'Stream is currently offline.'
  },
};

export default defaultTextValues;
